module.exports = __webpack_public_path__ + "static/media/tick.2f1af7a7.gif";